import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import jwt_Decode from 'jwt-decode';
import { NgOtpInputComponent } from 'ng-otp-input';
import { Membro } from 'src/app/modules/_models/membro';
import { AuthService } from 'src/app/modules/_services/auth.service';
import { FidelidadeService } from 'src/app/modules/_services/fidelidade.service';
import * as alerts from '../../../_functions/alerts';
import { statusAtivo } from '../../../_models/statusMembroLogin.model';
import { sucessoEnvioCodigo } from '../../../_models/sucessoEnvioCodigo';
import { ValidacaoService } from '../../../_services/validacao.service';

@Component({
  selector: 'app-entrar',
  templateUrl: './entrar.component.html',
  styleUrls: ['./entrar.component.scss'],
})
export class EntrarComponent implements OnInit {
  @ViewChild(NgOtpInputComponent, { static: false })
  ngOtpInput: NgOtpInputComponent;
  otpInputConfig = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      width: '2.5rem',
      height: '3rem',
      'border-radius': '1.5rem',
      'font-family': 'Sagona',
      'font-size': '24px',
    },
  };

  readonly CAMPO_SENHA: string = 'senha';
  readonly CAMPO_CONFIRMACAO_SENHA: string = 'confirmacaoSenha';
  readonly ICONE_OLHO_ABERTO: string = 'assets/images/icons/olho_aberto.svg';
  readonly ICONE_OLHO_FECHADO: string = 'assets/images/icons/olho_fechado.svg';

  // Etapas do login
  public readonly ETAPA__LOGIN: number = 1;
  public readonly ETAPA__SENHA: number = 2;
  public readonly ETAPA__PINCODE: number = 3;
  public readonly ETAPA__COMPLETARCADASTRO: number = 4;
  private sessaoAtual: statusAtivo;
  public habilitaReenvio: boolean = false;
  public counter: number = 30;
  public counterC: number = 10;
  public paraEnviarCodigo: string = '';
  public metodoValidar: string = '';
  public codigoInvalido: string = 'Código inválido';
  public habilitaCodigoInvalido: boolean = false;
  public naoPossuiSenha: boolean = false;
  public realizandoLogin: boolean = false;
  public realizandoEnvioEmail: boolean = false;
  public realizandoEnvioCelular: boolean = false;
  public completarCadastro: boolean = false;
  exibirLoader: boolean = false;
  exibePopupGenerico: boolean = false;
  tituloModalGenerico: string = '';

  // Metodos de login
  private readonly METODO__EMAIL: string = 'email';
  private readonly METODO__CELULAR: string = 'celular';
  private metodoDeLogin: string = '';
  popupLogin: string = '';

  membro: Membro | undefined;
  acessoForm: UntypedFormGroup;
  confimacaoAceite: UntypedFormGroup;
  etapaLogin: number = 1;
  entrando: boolean = false;
  mensagemLogin: string = '';
  resultadoValidaCampo: string = '';
  existeMsgError: boolean = false;
  msgInvalida: string = '';

  public bloqueioPopup: boolean = false;

  public ativo: boolean = false;
  public idStatus: number = undefined;
  public token: string = '';
  public intervalId: any = '';
  podeLogar: boolean = false;

  tipoCampoSenha: boolean = false;
  tipoCampoConfirmacaoSenha: boolean = false;
  iconeSenha: string = this.ICONE_OLHO_FECHADO;
  iconeConfirmacaoSenha: string = this.ICONE_OLHO_FECHADO;
  descricaoModalGenerico: string[] = [];

  bloquearPopupEtapaCadastro: boolean = false;

  @Output() public irParaAcesso: EventEmitter<null> = new EventEmitter();
  @Output() public idTipoStatus: EventEmitter<number> = new EventEmitter();
  @Output() public membroToken: EventEmitter<string> = new EventEmitter();
  @Output() public irParaEsqueci: EventEmitter<null> = new EventEmitter();
  @Output() public enviarBloqueioPoup: EventEmitter<Boolean> =
    new EventEmitter();
  @Input() public etapaAtual: number;
  @Input() public redirectLink: string = '';
  @Input() public Urlreturn: string = '';

  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private datepipe: DatePipe,
    private router: Router,
    private route: ActivatedRoute,
    private validacaoService: ValidacaoService,
    private fidelidadeService: FidelidadeService,
    private renderer: Renderer2
  ) {
    this.acessoForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.minLength(11)]],
      senha: [''],
      nomeAceite: [''],
      nascimentoAceite: [''],
      aceiteTermos: [false],
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params.popup) {
        this.popupLogin = atob(params.popup);
        this.acessoForm.get('email').setValue(this.popupLogin);
      }

      if (params.tipoStatus) {
        this.token = params.tipoStatus;
        const decorded: any = jwt_Decode(params.tipoStatus);
        this.sessaoAtual = decorded;
        this.authService.retornaStatusMembro(decorded.sub, '', true).subscribe(
          (sucesso: any) => {
            this.sessaoAtual = sucesso;
          },
          (falha: any) => console.error(falha)
        );
        this.fidelidadeService
          .obterMembroPorToken(params.tipoStatus)
          .subscribe((sucessoMember: Membro) => {
            this.membro = sucessoMember;
            this.acessoForm.patchValue({
              nomeAceite: sucessoMember.nome,
              nascimentoAceite: this.datepipe.transform(
                sucessoMember.dataNascimento,
                'ddMMyyyy'
              ),
            });
          });
      }

      if (params['reaceite']) {
        let parametro = atob(params['reaceite']);
        this.bloquearPopupEtapaCadastro = Boolean(parametro);
      }
    });
    if (this.etapaAtual) this.etapaLogin = this.etapaAtual;

    this.bloquearPopup();
  }

  atualizarStatus() {
    this.exibirLoader = true;
    event.preventDefault();
    this.realizandoLogin = true;
    this.membro.aceiteTermo = true;
    this.membro.enviaComunicacao = true;
    this.membro.senha = null;
    this.membro.nome = this.acessoForm.value.nomeAceite;
    this.membro.visualizarPopupHome = false;
    this.membro.dataNascimento = this.convertData(
      this.acessoForm.value.nascimentoAceite
    );
    if (this.membro.tipoStatus === 11) this.membro.tipoStatus = 1;
    if (this.metodoValidar === 'celular') this.membro.telefoneValidado = true;
    if (this.metodoValidar === 'email') this.membro.emailValidado = true;
    if (this.token) this.sessaoAtual.token = this.token;
    this.fidelidadeService
      .atualizarMembroSemToken(
        this.membro,
        this.membro.telefone || this.membro.email,
        this.sessaoAtual.token,
      )
      .subscribe(
        (sucesso) => {
          this.realizandoLogin = false;
          this.exibirLoader = false;
          this.renderer.removeClass(document.body, 'no-scroll');
          this.authService.LocalStorage.salvarMembro(sucesso);
          this.processarSucesso(this.sessaoAtual);
        },
        (error) => {
          console.error(error);
          this.exibirLoader = false;
          this.renderer.removeClass(document.body, 'no-scroll');
        }
      );
  }

  convertData(data: string): any {
    const ano = data.slice(4);
    const mes = data.slice(2, 4);
    const dia = data.slice(0, 2);

    return `${ano}-${mes}-${dia}`;
  }

  formatCPF(cpf: string): string {
    const regex = /[\.\-]/g;

    if (regex.test(cpf)) {
      return cpf.replace(regex, '');
    }

    return cpf;
  }

  setEmailCpf(event: any) {
    if (!event.target.value) localStorage.removeItem('emailsms');
    const membro = {
      email: "",
      cpf: "",
      pincode: 0
    };

    if (event.target.value.includes("@")) {
      membro.email = event.target.value;
    }
    else {
      membro.cpf = this.formatCPF(event.target.value);
    };

    localStorage.setItem('emailsms', window.btoa(JSON.stringify(membro)));
  }

  acessar() {
    const form = this.acessoForm.value;
    let verificaStatus = true;
    this.existeMsgError = false;
    this.entrando = true;
    this.msgInvalida = '';
    this.idStatus = undefined;

    this.resultadoValidaCampo = this.identificarCampo(form.email);

    if (this.existeMsgError) {
      this.entrando = false;
    } else {
      if (this.idStatus == undefined) {
        this.authService
          .retornaStatusMembro(form.email, form.senha, verificaStatus)
          .subscribe(
            (sucesso: any) => this.processarSucessoRetornaStatusMembro(sucesso),
            (falha: any) => this.processarFalha(falha)
          );
      }

      if (this.idStatus != 8 && this.podeLogar) {
        this.authService.loginComSenha(form.email, form.senha).subscribe(
          (sucesso: any) => this.processarSucesso(sucesso),
          (falha: any) => this.processarFalha(falha)
        );
      }
    }
  }

  private limparDescricao() {
    this.descricaoModalGenerico = [];
  }

  public mostrarPopupTermos() {
    this.limparDescricao();
    this.exibirLoader = true;

    this.fidelidadeService.obterConfiguracaoPorDescricao('termos').subscribe(
      (sucesso) => {
        this.processarSucessoTermos(sucesso);
      },
      (falha) => {
        this.processarFalhaTermos(falha);
      }
    );
  }

  private processarSucessoTermos(response: any) {
    let linhas = response.valor.split('\n');

    for (let index = 1; index < linhas.length; index++) {
      if (linhas[index] == '\r') continue;

      this.descricaoModalGenerico.push(`${linhas[index]}<br><br>`);
    }

    this.exibirLoader = false;

    this.exibePopupGenerico = true;
    this.tituloModalGenerico = linhas[0];
  }

  private processarFalhaTermos(fail: any) {
    this.exibirLoader = false;
    console.error('Ocorreu um erro ao tentar obter os termos', fail);
  }

  public mostrarPopupRegulamento() {
    this.limparDescricao();
    this.exibirLoader = true;

    this.fidelidadeService
      .obterConfiguracaoPorDescricao('regulamento')
      .subscribe(
        (sucesso) => {
          this.processarSucessoRegulamento(sucesso);
        },
        (falha) => {
          this.processarFalhaRegulamento(falha);
        }
      );
  }

  private processarSucessoRegulamento(response: any) {
    var linhas = response.valor.split('\n');

    for (let index = 0; index < linhas.length; index++) {
      if (linhas[index] == '\r') continue;

      this.descricaoModalGenerico.push(`${linhas[index]}<br><br>`);
    }

    this.exibirLoader = false;
    this.exibePopupGenerico = true;
    this.tituloModalGenerico = linhas[0];
  }

  private processarFalhaRegulamento(fail: any) {
    this.exibirLoader = false;
    console.error('tOcorreu um erro ao tentar obter o regulamento', fail);
  }

  identificarCampo(campo: string): string {
    this.msgInvalida = '';
    const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const regexCpf = /^[0-9]{3}.?[0-9]{3}.?[0-9]{3}-?[0-9]{2}/;
    if (regexEmail.test(campo)) {
      if (!this.validacaoService.validarEmail(campo)) {
        this.existeMsgError = true;
        return (this.msgInvalida = `E-mail inválido`);
      }
    } else if (regexCpf.test(campo)) {
      if (!this.validacaoService.validarCPF(campo)) {
        this.existeMsgError = true;
        return (this.msgInvalida = `CPF inválido`);
      }
    } else {
      this.existeMsgError = true;
      return (this.msgInvalida = `E-mail inválido`);
    }
  }

  processarSucessoRetornaStatusMembro(res: statusAtivo) {
    this.sessaoAtual = res;

    this.token = res.token;
    this.idStatus = res.tipoStatus;
    this.entrando = false;
    if (this.idStatus === 8 || this.idStatus === 6 || this.idStatus === 12) {
      // this.acessoForm.controls['email'].setValue('');
      this.irParaCadastro();
      return;
    }
    if (this.idStatus === 9) {
      this.acessoForm.controls['email'].setValue('');
      return alerts.exibirSwal(
        'warning',
        'Atenção',
        'Parece que seu cadastro não foi aprovado pelo responsável... Caso seja maior de idade contate-nos para <a href="https://lovers.cacaushow.com.br/ajuda/cacaulovers">corrigir seu acesso!</a>',
        'center',
        8000
      );
    }
    if (!res.ativo) {
      return this.verificaStatusEAtivo(res.tipoStatus, res.ativo);
    }
    if (this.idStatus === 7 || this.idStatus === 11) {
      this.podeLogar = true;
      this.naoPossuiSenha = true;
    }
    if (this.idStatus !== 8 && this.idStatus !== 6) {
      this.etapaLogin = this.ETAPA__SENHA;
      this.podeLogar = true;
    }
  }

  retornaCpfFormatado(): string {
    const cpf = this.acessoForm.controls['email'].value;
    const cpfSemPontuacao = cpf.replace(/[^\d]/g, '');
    const grupo1 = cpfSemPontuacao.substring(0, 3);
    const grupo2 = cpfSemPontuacao.substring(3, 6);
    const grupo3 = cpfSemPontuacao.substring(6, 9);
    const grupo4 = cpfSemPontuacao.substring(9, 11);

    const cpfFinal = `${grupo1}.${grupo2}.${grupo3}-${grupo4}`;

    return cpfFinal;
  }

  verificaStatusEAtivo(status: number, ativo: boolean) {
    this.entrando = false;

    const statusBloqueio = [1, 2, 3, 4, 5, 7, 8, 9];

    this.acessoForm.controls['email'].setValue('');

    if (statusBloqueio.includes(status) && !ativo) {
      return alerts.exibirSwal(
        'warning',
        'Atenção',
        'Existe alguma inconsistência no seu acesso, contate o <a href="https://lovers.cacaushow.com.br/ajuda/cacaulovers">SAC</a>',
        'center',
        8000
      );
    }
  }

  processarSucesso(response: statusAtivo, buscaMembro: boolean = true) {
    this.entrando = true;
    this.authService.LocalStorage.salvarDadosLocaisUsuario(response);

    if (buscaMembro) {
      this.fidelidadeService.obterMembro().subscribe({
        next: (res: any) => this.processarSucessoObterMembro(res),
        error: (error) => {
          this.entrando = false;
          //@ts-ignore
          window.dataLayer = window.dataLayer || [];
          //@ts-ignore
          window.dataLayer.push({
            event: 'login',
            status: 'error',
            error_type: error,
          });
        },
      });
    }
  }

  processarSucessoObterMembro(res: any) {
    this.authService.LocalStorage.salvarMembro(res);

    this.ativo = res.ativo;

    let dadosValidos =
      (res.telefoneValidado ||
        res.emailValidado ||
        (!res.emailValidado && !this.emailEObrigatorio(res))) &&
      this.dataNascimentoValida(res);
    if (!dadosValidos) {
      this.authService.LocalStorage.salvarDadosValidados(false);
      this.authService.LocalStorage.salvarRedirectLink(this.redirectLink);
    } else {
      this.authService.LocalStorage.salvarDadosValidados(true);
      this.authService.LocalStorage.salvarRedirectLink('');
    }

    this.sessaoAtual = {
      ativo: undefined,
      nome: undefined,
      tipoStatus: undefined,
      token: undefined,
      urlSSo: undefined,
    };

    this.realizandoLogin = false;

    if (this.redirectLink !== '') {
      this.router.navigateByUrl(this.redirectLink);
      this.entrando = false;
      return;
    } else if (this.Urlreturn !== '') {
      this.router.navigateByUrl(this.Urlreturn);
      this.entrando = false;
      return;
    }

    //@ts-ignore
    window.dataLayer = window.dataLayer || [];
    //@ts-ignore
    window.dataLayer.push({
      event: 'login',
      status: 'success',
    });
    this.router.navigate(['/index']);
  }

  dataNascimentoValida(membro: any) {
    const dataNascimentoMinima = new Date(1753, 0, 1, 0, 0, 0);

    const nascimento: string = membro.dataNascimento;
    const ano = Number(nascimento.substring(0, 4));
    const mes = Number(nascimento.substring(5, 7));
    const dia = Number(nascimento.substring(8, 10));

    var dataFinal = `${ano}/${mes}/${dia}`;

    const nascimentoDate: Date = new Date(dataFinal);

    if (dataNascimentoMinima.toISOString() == nascimentoDate.toISOString())
      return false;
    else return true;
  }

  emailEObrigatorio(membro: any) {
    const nascimento: string = membro.dataNascimento;
    const ano = Number(nascimento.substring(0, 4));
    const mes = Number(nascimento.substring(5, 7));
    const dia = Number(nascimento.substring(8, 10));

    var dataFinal = `${ano}/${mes}/${dia}`;

    const nascimentoDate: Date = new Date(dataFinal);

    let age = this.getAge(nascimentoDate);

    if (age >= 65) return false;
    else return true;
  }

  getAge(birthDate: Date) {
    var today = new Date();
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  processarFalha(fail: any) {
    this.mensagemLogin = '';
    this.entrando = false;

    if (fail.erro == 0 || fail == 'Registro não encontrado') {
      // alerts.exibirToast('error', 'Usuário não cadastrado');
      this.irParaCadastro();
    } else if (fail.erro == 1) {
      this.mensagemLogin = `
        Obaaa, ´*você já é um cacau lover*´ porém falta apenas uma etapa para seguir adiante.
        Clique em ´*Esqueci Minha Senha*´ para finalizar seu cadastro!`;
    } else if (fail == 'CPF Bloqueado') {
      alerts.exibirToast('error', fail);
    } else {
      alerts.exibirToast('error', 'Usuário ou senha inválidos!');
    }
  }

  trocarTipoCampoSenha(campoValidacao: string, icone: string) {
    if (campoValidacao === this.CAMPO_SENHA) {
      this.tipoCampoSenha = !this.tipoCampoSenha;
      this.iconeSenha = this.obterIconeSenha(icone);
    } else if (campoValidacao === this.CAMPO_CONFIRMACAO_SENHA) {
      this.tipoCampoConfirmacaoSenha = !this.tipoCampoConfirmacaoSenha;
      this.iconeConfirmacaoSenha = this.obterIconeSenha(icone);
    }
  }

  private obterIconeSenha(icone: string) {
    if (icone.includes(this.ICONE_OLHO_FECHADO)) return this.ICONE_OLHO_ABERTO;
    else return this.ICONE_OLHO_FECHADO;
  }

  irParaEsqueciSenha() {
    let ehCpf = this.acessoForm.get('email').value;
    this.irParaEsqueci.emit();

    if (!ehCpf.includes('@')) {
      this.router.navigate(['/home'], {
        queryParams: {
          popupEsqueciSenha: btoa(this.acessoForm.get('email').value),
        },
      });
    }
  }

  irParaCadastro() {
    this.membroToken.emit(this.token);
    this.idTipoStatus.emit(this.idStatus);
    this.irParaAcesso.emit();
    this.router.navigate(['/home'], {
      queryParams: {
        popupCadastro: btoa(this.acessoForm.get('email').value),
      },
    });
  }

  voltarEtapa() {
    this.etapaLogin -= 1;
    clearInterval(this.intervalId);

    if (this.etapaLogin === this.ETAPA__LOGIN) {
      this.acessoForm.reset();
      this.podeLogar = false;
      this.token = '';
      this.idStatus = undefined;
      this.sessaoAtual = {
        ativo: undefined,
        nome: undefined,
        tipoStatus: undefined,
        token: undefined,
        urlSSo: undefined,
      };
    }
    if (this.etapaLogin === this.ETAPA__SENHA) {
      this.metodoDeLogin = '';
      this.paraEnviarCodigo = '';
    }
  }

  public metodoLogin(metodo: string) {
    this.habilitaReenvio = false;
    this.metodoValidar = metodo;

    this.counter = 60;
    this.intervalId = setInterval(() => {
      if (this.counter > 0) {
        this.counter--;
        this.habilitaReenvio = false;
      } else {
        this.habilitaReenvio = true;
      }
    }, 1000);

    if (metodo === this.METODO__EMAIL) {
      this.realizandoEnvioEmail = true;
      this.metodoDeLogin = metodo;
      this.fidelidadeService
        .enviarEmailValidarEmailComToken(this.sessaoAtual.token)
        .subscribe(
          (sucesso: sucessoEnvioCodigo) => {
            this.etapaLogin = this.ETAPA__PINCODE;
            this.paraEnviarCodigo = `${sucesso.resultado}`;
            this.realizandoEnvioEmail = false;
          },
          (falha: any) => {
            console.log(falha);
            this.realizandoEnvioEmail = false;
            return alerts.exibirSwal(
              'warning',
              'Atenção',
              'Houve um problema para enviar o código.',
              'center',
              8000
            );
          }
        );
    }
    if (metodo === this.METODO__CELULAR) {
      this.realizandoEnvioCelular = true;
      this.metodoDeLogin = metodo;
      this.fidelidadeService
        .enviarSmsValidarCampoComToken(this.sessaoAtual.token)
        .subscribe(
          (sucesso: any) => {
            this.etapaLogin = this.ETAPA__PINCODE;
            this.paraEnviarCodigo = `${sucesso.resultado}`;
            this.realizandoEnvioCelular = false;
          },
          (falha: any) => {
            console.log(falha);
            this.realizandoEnvioCelular = false;
            return alerts.exibirSwal(
              'warning',
              'Atenção',
              'Houve um problema para enviar o código.',
              'center',
              8000
            );
          }
        );
    }
  }

  public validarCodigo(otp: any) {
    let pinCode: string = otp;

    if (pinCode?.length < 6) return;

    if (this.metodoDeLogin == this.METODO__CELULAR) this.validarSms(pinCode);
    if (this.metodoDeLogin == this.METODO__EMAIL) this.validarEmail(pinCode);
  }

  private validarSms(pinCode: string) {
    this.realizandoLogin = true;
    this.fidelidadeService
      .validarPinCodeSmsValidarCampoComToken(pinCode)
      .subscribe(
        (sucesso) => {
          if (sucesso.resultado) {
            this.sessaoAtual.token = sucesso.resultado;
            this.fidelidadeService
              .obterMembroPorToken(this.sessaoAtual.token)
              .subscribe((sucessoMember: Membro) => {
                this.membro = sucessoMember;
                this.acessoForm.patchValue({
                  nomeAceite: sucessoMember.nome,
                  nascimentoAceite: this.datepipe.transform(
                    sucessoMember.dataNascimento,
                    'ddMMyyyy'
                  ),
                });
              });
          }
          if (
            !sucesso.erro &&
            (this.sessaoAtual.tipoStatus === 7 ||
              (this.sessaoAtual.tipoStatus === 11 && sucesso.resultado))
          ) {
            this.bloquearPopup();
            return (this.etapaLogin = this.ETAPA__COMPLETARCADASTRO);
          }
          if (!sucesso.erro) {
            this.processarSucesso(this.sessaoAtual, false);
            this.fidelidadeService.obterMembro().subscribe(
              (sucesso: Membro) => {
                sucesso.telefoneValidado = true;
                sucesso.senha = null;

                this.fidelidadeService
                  .atualizarMembroValidaDados(
                    sucesso,
                    sucesso.email || sucesso.email
                  )
                  .subscribe(
                    (sucesso) => {
                      this.authService.LocalStorage.salvarMembro(sucesso);
                      this.processarSucesso(this.sessaoAtual);
                    },
                    (falha) => {
                      console.log(falha);
                      if (falha.includes('O campo Email é obrigatório!')) {
                        this.processarSucesso(this.sessaoAtual);
                      }
                      this.realizandoLogin = false;
                    }
                  );
              },
              (falha) => {
                console.log(falha);
                this.realizandoLogin = false;
              }
            );
          } else {
            this.realizandoLogin = false;
            this.counterC = 10;
            // this.ngxOtp.clear();
            this.habilitaCodigoInvalido = true;
            setTimeout(() => {
              if (this.counterC > 0) {
                this.counterC--;
                this.habilitaCodigoInvalido = true;
              } else {
                this.habilitaCodigoInvalido = false;
              }
            }, 1000);
            return;
          }
        },
        (falha) => {
          console.log(falha);
          this.realizandoLogin = false;
          // this.ngxOtp.clear();
          return alerts.exibirSwal(
            'warning',
            'Atenção',
            'Houve um problema para validar o código, é preciso reenviar o código.',
            'center',
            8000
          );
        }
      );
  }

  private validarEmail(pinCode: string) {
    this.realizandoLogin = true;
    this.fidelidadeService
      .validarPinCodeEmailValidarCampoComToken(pinCode)
      .subscribe(
        (sucesso) => {
          if (sucesso.resultado) {
            this.sessaoAtual.token = sucesso.resultado;
            this.fidelidadeService
              .obterMembroPorToken(this.sessaoAtual.token)
              .subscribe((sucessoMember: Membro) => {
                this.membro = sucessoMember;
                this.acessoForm.patchValue({
                  nomeAceite: sucessoMember.nome,
                  nascimentoAceite: this.datepipe.transform(
                    sucessoMember.dataNascimento,
                    'ddMMyyyy'
                  ),
                });
              });
          }
          if (
            !sucesso.erro &&
            (this.sessaoAtual.tipoStatus === 7 ||
              this.sessaoAtual.tipoStatus === 11)
          ) {
            this.bloquearPopup();
            return (this.etapaLogin = this.ETAPA__COMPLETARCADASTRO);
          }
          if (!sucesso.erro === true) {
            this.processarSucesso(this.sessaoAtual, false);
            this.fidelidadeService.obterMembro().subscribe(
              (sucesso: Membro) => {
                sucesso.emailValidado = true;
                sucesso.senha = null;

                this.fidelidadeService
                  .atualizarMembroValidaDados(
                    sucesso,
                    sucesso.email || sucesso.email
                  )
                  .subscribe(
                    (sucesso) => {
                      this.authService.LocalStorage.salvarMembro(sucesso);
                      this.processarSucesso(this.sessaoAtual);
                    },
                    (falha) => {
                      console.log(falha);
                      this.realizandoLogin = false;
                    }
                  );
              },
              (falha) => {
                console.log(falha);
                this.realizandoLogin = false;
              }
            );
          } else {
            this.realizandoLogin = false;
            // this.ngxOtp.clear();
            this.habilitaCodigoInvalido = true;
            setTimeout(() => {
              this.counterC = 10;
              if (this.counterC > 0) {
                this.counterC--;
                this.habilitaCodigoInvalido = true;
              } else {
                this.habilitaCodigoInvalido = false;
              }
            }, 1000);
            return;
          }
        },
        (falha) => {
          console.log(falha);
          this.realizandoLogin = false;
          // this.ngxOtp.clear();
          return alerts.exibirSwal(
            'warning',
            'Atenção',
            'Houve um problema para validar o código, é preciso reenviar o código.',
            'center',
            8000
          );
        }
      );
  }

  reenviarCodigo() {
    this.counter = 60;
    this.ngOtpInput.setValue('');

    if (this.metodoDeLogin === this.METODO__EMAIL) {
      this.fidelidadeService
        .enviarEmailValidarEmailComToken(this.sessaoAtual.token)
        .subscribe(
          (sucesso: any) => { },
          (falha: any) => console.log(falha)
        );
    }
    if (this.metodoDeLogin === this.METODO__CELULAR) {
      this.fidelidadeService
        .enviarSmsValidarCampoComToken(this.sessaoAtual.token)
        .subscribe(
          (sucesso: any) => { },
          (falha: any) => console.log(falha)
        );
    }
  }

  private bloquearPopup() {
    if (this.etapaLogin == this.ETAPA__COMPLETARCADASTRO) {
      this.bloqueioPopup = true;
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { reaceite: btoa('true') },
        queryParamsHandling: 'merge',
      });
      this.enviarBloqueioPoup.emit(this.bloqueioPopup);
    }
  }
}
